import * as $$Array from "bs-platform/lib/es6/array.js";
import * as ArrayLabels from "bs-platform/lib/es6/arrayLabels.js";
import * as Bolt0_list$Bolt0 from "bolt0/./bolt0_list.bs.js";

function unwrap(x) {
  return $$Array.to_list(ArrayLabels.map($$Array.to_list, x));
}

function wrap(x) {
  return $$Array.of_list(Bolt0_list$Bolt0.map($$Array.of_list, x));
}

export { unwrap, wrap };
/* No side effect */